import { CircularProgress } from "@mui/material"
import { Box } from "@mui/system"


const CircleLoader = ({sx}) => {
    return <Box display="flex" justifyContent="center">
        <CircularProgress sx={sx} />
    </Box> 
}

export default CircleLoader;